<div class="center-on-page customloaderLine">
  <div class="loaderLine " role="status">
    <img src="assets/img/loader/loadingLines.gif" alt="Loading Line Loader">
    <h5> {{ 'PROCESSING_YOUR_REQUEST' | translate }} </h5>
    <div class="short_text">
      <p>{{ 'TAKE_A_MINUTE' | translate }}</p>
      <p class="bold">{{ 'CLOSE_WINDOW' | translate }}</p>
    </div>
  </div>
</div>